import {PortableTextComponents} from "@portabletext/react";
import {Link, Typography} from "@mui/material";

export const portableTextComponents: PortableTextComponents = {
  block: {
    normal: ({children}) => (
      <Typography
        color="text.primary"
        variant="body1"
        fontWeight="bold"
        textAlign="center"
        marginBottom="12px"
      >
        {children}
      </Typography>
    ),
    h3: ({children}) => (
      <Typography
        color="text.primary"
        variant="h6"
        fontWeight="bold"
        textAlign="center"
        marginBottom="12px"
      >
        {children}
      </Typography>
    ),
  },
  list: {
    bullet: ({children}) => (
      <ul style={{margin: "0 0 12px 20px"}}>
        {children}
      </ul>
    ),
  },
  listItem: {
    bullet: ({children}) => (
      <li>
        <Typography
          color="text.primary"
          variant="body1"
          fontWeight="bold"
        >
          {children}
        </Typography>
      </li>
    ),
  },
  marks: {
    link: ({value, children}) => (
      <Link href={value?.href} target="_blank" rel="noopener">
        {children}
      </Link>
    ),
  },
};
